import React from 'react';
import { connect } from 'unistore/react';

import { Button } from '@components';
import { openNewLink } from '@utils/customLib';

const openLink = () => {
	openNewLink('https://bitbns.com/trade/#/signup');
};

export default connect('isLoggedIn')(({ isLoggedIn }) => {
	return isLoggedIn === 1 ? null : (
		<div className="bg-white border-b border-t border-gray-300 text-center">
			<div className="container py-12 px-4">
				<h3 className="text-2xl my-4 font-bold">
					Start Trading in an <br />
					Instant
				</h3>
				<p className="u-para--readable mx-auto my-4">
					Board the trading wagon now!
				</p>
				<Button
					onClick={openLink}
					triangle="right"
					variant="primary"
					className="mb-8"
				>
					Sign Up For Free
				</Button>
			</div>
		</div>
	);
});
